import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { is, fromJS } from 'immutable';

import PreviewCode from './PreviewCode';

export default class PreviewChild extends Component {
  static propTypes = {
    node: PropTypes.object,
    parentType: PropTypes.string,
    parentIndex: PropTypes.string,
  };

  shouldComponentUpdate(nextProps) {
    return !is(fromJS(this.props.node), fromJS(nextProps.node));
  }

  isFence = () => {
    const { node: { type }, parentType } = this.props;
    return parentType === 'pre' && type === 'code';
  };

  getChildren = () => {
    const { node: { type, children, attr = {} }, parentIndex } = this.props;
    return children ? children.map((child, index) => {
      // 只有当是pre时，才赋新的key，从而force render
      const key = `${parentIndex}-${index}`;
      if (this.isFence()) {
        const { className: lang = '' } = attr;
        return (
          <PreviewCode
            key={key}
            node={child}
            codeKey={key}
            lang={lang}
          />
        );
      }
      return (
        <PreviewChild
          key={key}
          node={child}
          parentType={type}
          parentIndex={`${parentIndex}-${index}`}
        />
      );
    }) : null;
  };

  render() {
    const { node, parentType } = this.props;
    const { type, value, attr = {} } = node;
    const children = this.getChildren();
    const props = {
      ...attr,
      ref: (el) => {
        this.el = el;
      },
    };
    if (type === 'text') {
      if (parentType === 'table' || parentType === 'thead' || parentType === 'tbody') {
        return value.trim() ? value : null;
      }
      return value;
    }
    if (this.isFence()) {
      return (
        <Fragment>
          {children}
        </Fragment>
      );
    }
    return React.createElement(type, props, children);
  }
}



// WEBPACK FOOTER //
// ./src/components/PreviewVDOM/PreviewChild.js